export const ZAPIER_APP_BASE_URL = process.env.ZAPIER_APP_BASE_URL || '';
